import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

/** 集群调度器 resource-configurations 查询（GPU 校验等） */
export function getMaasResourceConfigurations(params: { workloadType: string; resourceType: string }) {
  return get<unknown[]>(`${PREFIX.vapis_v1_dc_ws(GROUPS.clusterScheduler)}/resource-configurations`, {
    ...(params || {}),
    availability: true,
  });
}
